import { useState } from "react";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

import MDBox from "components/atoms/MDBox";
import MDTypography from "components/atoms/MDTypography";

//import FormTextFieldFast from "components/molecules/Formik/FormTextFieldFast";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";

//import FormCheckboxGroup from "components/molecules/Formik/FormCheckboxGroup";

//import { roleOptions } from "pages/settings/user/new/schemas/setups";

function ParamSettings({
  mainForm,
  mainFormField,
  modeDisabled,
  dispatchMainError,
}) {
  //mainForm.values.param_P = 22;
  const { initialValues, setFieldValue } = mainForm;
  const [ASQ3Communication_CutoffLBValue, setASQ3Communication_CutoffLBValue] =
    useState(initialValues.ASQ3Communication_CutoffLB);
  const [ASQ3Communication_CutoffUBValue, setASQ3Communication_CutoffUBValue] =
    useState(initialValues.ASQ3Communication_CutoffUB);
  const [ASQ3GrossMotor_CutoffLBValue, setASQ3GrossMotor_CutoffLBValue] =
    useState(initialValues.ASQ3GrossMotor_CutoffLB);
  const [ASQ3GrossMotor_CutoffUBValue, setASQ3GrossMotor_CutoffUBValue] =
    useState(initialValues.ASQ3GrossMotor_CutoffUB);
  const [ASQ3FineMotor_CutoffLBValue, setASQ3FineMotor_CutoffLBValue] =
    useState(initialValues.ASQ3FineMotor_CutoffLB);
  const [ASQ3FineMotor_CutoffUBValue, setASQ3FineMotor_CutoffUBValue] =
    useState(initialValues.ASQ3FineMotor_CutoffUB);
  const [
    ASQ3ProblemSolving_CutoffLBValue,
    setASQ3ProblemSolving_CutoffLBValue,
  ] = useState(initialValues.ASQ3ProblemSolving_CutoffLB);
  const [
    ASQ3ProblemSolving_CutoffUBValue,
    setASQ3ProblemSolving_CutoffUBValue,
  ] = useState(initialValues.ASQ3ProblemSolving_CutoffUB);
  const [
    ASQ3PersonalSocial_CutoffLBValue,
    setASQ3PersonalSocial_CutoffLBValue,
  ] = useState(initialValues.ASQ3PersonalSocial_CutoffLB);
  const [
    ASQ3PersonalSocial_CutoffUBValue,
    setASQ3PersonalSocial_CutoffUBValue,
  ] = useState(initialValues.ASQ3PersonalSocial_CutoffUB);
  const [ASQ3_SE2_CutoffLBValue, setASQ3_SE2_CutoffLBValue] = useState(
    initialValues.ASQ3_SE2_CutoffLB
  );
  const [ASQ3_SE2_CutoffUBValue, setASQ3_SE2_CutoffUBValue] = useState(
    initialValues.ASQ3_SE2_CutoffUB
  );
  const [SDQ_Total_CutoffB1Value, setSDQ_Total_CutoffB1Value] = useState(
    initialValues.SDQ_Total_CutoffB1
  );
  const [SDQ_Total_CutoffB2Value, setSDQ_Total_CutoffB2Value] = useState(
    initialValues.SDQ_Total_CutoffB2
  );
  const [SDQ_Total_CutoffB3Value, setSDQ_Total_CutoffB3Value] = useState(
    initialValues.SDQ_Total_CutoffB3
  );
  const [SDQ_EmotionalProb_CutoffB1Value, setSDQ_EmotionalProb_CutoffB1Value] =
    useState(initialValues.SDQ_EmotionalProb_CutoffB1);
  const [SDQ_EmotionalProb_CutoffB2Value, setSDQ_EmotionalProb_CutoffB2Value] =
    useState(initialValues.SDQ_EmotionalProb_CutoffB2);
  const [SDQ_EmotionalProb_CutoffB3Value, setSDQ_EmotionalProb_CutoffB3Value] =
    useState(initialValues.SDQ_EmotionalProb_CutoffB3);
  const [SDQ_ConductProb_CutoffB1Value, setSDQ_ConductProb_CutoffB1Value] =
    useState(initialValues.SDQ_ConductProb_CutoffB1);
  const [SDQ_ConductProb_CutoffB2Value, setSDQ_ConductProb_CutoffB2Value] =
    useState(initialValues.SDQ_ConductProb_CutoffB2);
  const [SDQ_ConductProb_CutoffB3Value, setSDQ_ConductProb_CutoffB3Value] =
    useState(initialValues.SDQ_ConductProb_CutoffB3);
  const [SDQ_Hyperactivity_CutoffB1Value, setSDQ_Hyperactivity_CutoffB1Value] =
    useState(initialValues.SDQ_Hyperactivity_CutoffB1);
  const [SDQ_Hyperactivity_CutoffB2Value, setSDQ_Hyperactivity_CutoffB2Value] =
    useState(initialValues.SDQ_Hyperactivity_CutoffB2);
  const [SDQ_Hyperactivity_CutoffB3Value, setSDQ_Hyperactivity_CutoffB3Value] =
    useState(initialValues.SDQ_Hyperactivity_CutoffB3);
  const [SDQ_PeerProb_CutoffB1Value, setSDQ_PeerProb_CutoffB1Value] = useState(
    initialValues.SDQ_PeerProb_CutoffB1
  );
  const [SDQ_PeerProb_CutoffB2Value, setSDQ_PeerProb_CutoffB2Value] = useState(
    initialValues.SDQ_PeerProb_CutoffB2
  );
  const [SDQ_PeerProb_CutoffB3Value, setSDQ_PeerProb_CutoffB3Value] = useState(
    initialValues.SDQ_PeerProb_CutoffB3
  );
  const [SDQ_Prosocial_CutoffB1Value, setSDQ_Prosocial_CutoffB1Value] =
    useState(initialValues.SDQ_Prosocial_CutoffB1);
  const [SDQ_Prosocial_CutoffB2Value, setSDQ_Prosocial_CutoffB2Value] =
    useState(initialValues.SDQ_Prosocial_CutoffB2);
  const [SDQ_Prosocial_CutoffB3Value, setSDQ_Prosocial_CutoffB3Value] =
    useState(initialValues.SDQ_Prosocial_CutoffB3);

  const {
    ASQ3Communication_CutoffLB,
    ASQ3Communication_CutoffUB,
    ASQ3GrossMotor_CutoffLB,
    ASQ3GrossMotor_CutoffUB,
    ASQ3FineMotor_CutoffLB,
    ASQ3FineMotor_CutoffUB,
    ASQ3ProblemSolving_CutoffLB,
    ASQ3ProblemSolving_CutoffUB,
    ASQ3PersonalSocial_CutoffLB,
    ASQ3PersonalSocial_CutoffUB,
    ASQ3_SE2_CutoffLB,
    ASQ3_SE2_CutoffUB,
    SDQ_Total_CutoffB1,
    SDQ_Total_CutoffB2,
    SDQ_Total_CutoffB3,
    SDQ_EmotionalProb_CutoffB1,
    SDQ_EmotionalProb_CutoffB2,
    SDQ_EmotionalProb_CutoffB3,
    SDQ_ConductProb_CutoffB1,
    SDQ_ConductProb_CutoffB2,
    SDQ_ConductProb_CutoffB3,
    SDQ_Hyperactivity_CutoffB1,
    SDQ_Hyperactivity_CutoffB2,
    SDQ_Hyperactivity_CutoffB3,
    SDQ_PeerProb_CutoffB1,
    SDQ_PeerProb_CutoffB2,
    SDQ_PeerProb_CutoffB3,
    SDQ_Prosocial_CutoffB1,
    SDQ_Prosocial_CutoffB2,
    SDQ_Prosocial_CutoffB3,
  } = mainFormField;

  return (
    <Card id="cusum-variables" sx={{ overflow: "visible" }}>
      <MDBox m={3}>
        <MDBox mb={3}>
          <MDTypography variant="h5">(1) Settings for ASQ-3</MDTypography>
        </MDBox>

        <MDBox>
          <Grid
            container
            rowSpacing={{ xs: 1, sm: 2 }}
            columnSpacing={{ xs: 1, sm: 3 }}
          >
            {/* ASQ3Communication_CutoffLB */}
            <Grid item xs={6} xl={3}>
              <MDTypography variant="body3" fontWeight="bold">
                {ASQ3Communication_CutoffLB.label}
              </MDTypography>
            </Grid>
            <Grid item xs={5} xl={2}>
              <TextField
                id="ASQ3-Communication-BLACK"
                label="ASQ3 Communication (BLACK)"
                variant="outlined"
                type={"number"}
                InputProps={{
                  inputProps: { min: 0 },
                  startAdornment: (
                    <InputAdornment position="start">{"<="}</InputAdornment>
                  ),
                }}
                value={ASQ3Communication_CutoffLBValue.toString()}
                onChange={(e) => {
                  if (!!e.target.value) {
                    setASQ3Communication_CutoffLBValue(
                      parseInt(e.target.value)
                    );
                    setFieldValue(
                      ASQ3Communication_CutoffLB.name,
                      parseInt(e.target.value)
                    );
                  }
                }}
              ></TextField>
            </Grid>
            <Grid item xs={1} xl={1}></Grid>
            {/* ASQ3Communication_CutoffUB */}
            <Grid item xs={6} xl={3}>
              <MDTypography variant="body3" fontWeight="bold">
                {ASQ3Communication_CutoffUB.label}
              </MDTypography>
            </Grid>
            <Grid item xs={5} xl={2}>
              <TextField
                id="ASQ3-Communication-WHITE"
                label="ASQ3 Communication (WHITE)"
                variant="outlined"
                type={"number"}
                InputProps={{
                  inputProps: { min: 0 },
                  startAdornment: (
                    <InputAdornment position="start">{">="}</InputAdornment>
                  ),
                }}
                value={ASQ3Communication_CutoffUBValue.toString()}
                onChange={(e) => {
                  if (!!e.target.value) {
                    setASQ3Communication_CutoffUBValue(
                      parseInt(e.target.value)
                    );
                    setFieldValue(
                      ASQ3Communication_CutoffUB.name,
                      parseInt(e.target.value)
                    );
                  }
                }}
              ></TextField>
            </Grid>
            <Grid item xs={1} xl={1}></Grid>
            {/* ASQ3GrossMotor_CutoffLB */}
            <Grid item xs={6} xl={3}>
              <MDTypography variant="body3" fontWeight="bold">
                {ASQ3GrossMotor_CutoffLB.label}
              </MDTypography>
            </Grid>
            <Grid item xs={5} xl={2}>
              <TextField
                id="ASQ3-GrossMotor-BLACK"
                label="ASQ3 Gross Motor (BLACK)"
                variant="outlined"
                type={"number"}
                InputProps={{
                  inputProps: { min: 0 },
                  startAdornment: (
                    <InputAdornment position="start">{"<="}</InputAdornment>
                  ),
                }}
                value={ASQ3GrossMotor_CutoffLBValue.toString()}
                onChange={(e) => {
                  if (!!e.target.value) {
                    setASQ3GrossMotor_CutoffLBValue(parseInt(e.target.value));
                    setFieldValue(
                      ASQ3GrossMotor_CutoffLB.name,
                      parseInt(e.target.value)
                    );
                  }
                }}
              ></TextField>
            </Grid>
            <Grid item xs={1} xl={1}></Grid>
            {/* ASQ3GrossMotor_CutoffUB */}
            <Grid item xs={6} xl={3}>
              <MDTypography variant="body3" fontWeight="bold">
                {ASQ3GrossMotor_CutoffUB.label}
              </MDTypography>
            </Grid>
            <Grid item xs={5} xl={2}>
              <TextField
                id="ASQ3-GrossMotor-WHITE"
                label="ASQ3 GrossMotor (WHITE)"
                variant="outlined"
                type={"number"}
                InputProps={{
                  inputProps: { min: 0 },
                  startAdornment: (
                    <InputAdornment position="start">{">="}</InputAdornment>
                  ),
                }}
                value={ASQ3GrossMotor_CutoffUBValue.toString()}
                onChange={(e) => {
                  if (!!e.target.value) {
                    setASQ3GrossMotor_CutoffUBValue(parseInt(e.target.value));
                    setFieldValue(
                      ASQ3GrossMotor_CutoffUB.name,
                      parseInt(e.target.value)
                    );
                  }
                }}
              ></TextField>
              {/*<FormTextFieldFast
                form={mainForm}
                type={"number"}
                field={ASQ3GrossMotor_CutoffUB}
                variant="outlined"
                disabled={modeDisabled}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">{">="}</InputAdornment>
                  ),
                }}
              />*/}
            </Grid>
            <Grid item xs={1} xl={1}></Grid>
            {/* ASQ3FineMotor_CutoffLB */}
            <Grid item xs={6} xl={3}>
              <MDTypography variant="body3" fontWeight="bold">
                {ASQ3FineMotor_CutoffLB.label}
              </MDTypography>
            </Grid>
            <Grid item xs={5} xl={2}>
              <TextField
                id="ASQ3-FineMotor-BLACK"
                label="ASQ3 Fine Motor (BLACK)"
                variant="outlined"
                type={"number"}
                InputProps={{
                  inputProps: { min: 0 },
                  startAdornment: (
                    <InputAdornment position="start">{"<="}</InputAdornment>
                  ),
                }}
                value={ASQ3FineMotor_CutoffLBValue.toString()}
                onChange={(e) => {
                  if (!!e.target.value) {
                    setASQ3FineMotor_CutoffLBValue(parseInt(e.target.value));
                    setFieldValue(
                      ASQ3FineMotor_CutoffLB.name,
                      parseInt(e.target.value)
                    );
                  }
                }}
              ></TextField>
            </Grid>
            <Grid item xs={1} xl={1}></Grid>
            {/* ASQ3FineMotor_CutoffUB */}
            <Grid item xs={6} xl={3}>
              <MDTypography variant="body3" fontWeight="bold">
                {ASQ3FineMotor_CutoffUB.label}
              </MDTypography>
            </Grid>
            <Grid item xs={5} xl={2}>
              <TextField
                id="ASQ3-FineMotor-WHITE"
                label="ASQ3 Fine Motor (WHITE)"
                variant="outlined"
                type={"number"}
                InputProps={{
                  inputProps: { min: 0 },
                  startAdornment: (
                    <InputAdornment position="start">{">="}</InputAdornment>
                  ),
                }}
                value={ASQ3FineMotor_CutoffUBValue.toString()}
                onChange={(e) => {
                  if (!!e.target.value) {
                    setASQ3FineMotor_CutoffUBValue(parseInt(e.target.value));
                    setFieldValue(
                      ASQ3FineMotor_CutoffUB.name,
                      parseInt(e.target.value)
                    );
                  }
                }}
              ></TextField>
            </Grid>
            <Grid item xs={1} xl={1}></Grid>
            {/* ASQ3ProblemSolving_CutoffLB */}
            <Grid item xs={6} xl={3}>
              <MDTypography variant="body3" fontWeight="bold">
                {ASQ3ProblemSolving_CutoffLB.label}
              </MDTypography>
            </Grid>
            <Grid item xs={5} xl={2}>
              <TextField
                id="ASQ3-ProblemSolving-BLACK"
                label="ASQ3 Problem Solving (BLACK)"
                variant="outlined"
                type={"number"}
                InputProps={{
                  inputProps: { min: 0 },
                  startAdornment: (
                    <InputAdornment position="start">{"<="}</InputAdornment>
                  ),
                }}
                value={ASQ3ProblemSolving_CutoffLBValue.toString()}
                onChange={(e) => {
                  if (!!e.target.value) {
                    setASQ3ProblemSolving_CutoffLBValue(
                      parseInt(e.target.value)
                    );
                    setFieldValue(
                      ASQ3ProblemSolving_CutoffLB.name,
                      parseInt(e.target.value)
                    );
                  }
                }}
              ></TextField>
            </Grid>
            <Grid item xs={1} xl={1}></Grid>
            {/* ASQ3ProblemSolving_CutoffUB */}
            <Grid item xs={6} xl={3}>
              <MDTypography variant="body3" fontWeight="bold">
                {ASQ3ProblemSolving_CutoffUB.label}
              </MDTypography>
            </Grid>
            <Grid item xs={5} xl={2}>
              <TextField
                id="ASQ3-ProblemSolving-WHITE"
                label="ASQ3 Problem Solving (WHITE)"
                variant="outlined"
                type={"number"}
                InputProps={{
                  inputProps: { min: 0 },
                  startAdornment: (
                    <InputAdornment position="start">{">="}</InputAdornment>
                  ),
                }}
                value={ASQ3ProblemSolving_CutoffUBValue.toString()}
                onChange={(e) => {
                  if (!!e.target.value) {
                    setASQ3ProblemSolving_CutoffUBValue(
                      parseInt(e.target.value)
                    );
                    setFieldValue(
                      ASQ3ProblemSolving_CutoffUB.name,
                      parseInt(e.target.value)
                    );
                  }
                }}
              ></TextField>
            </Grid>
            <Grid item xs={1} xl={1}></Grid>
            {/* ASQ3PersonalSocial_CutoffLB */}
            <Grid item xs={6} xl={3}>
              <MDTypography variant="body3" fontWeight="bold">
                {ASQ3PersonalSocial_CutoffLB.label}
              </MDTypography>
            </Grid>
            <Grid item xs={5} xl={2}>
              <TextField
                id="ASQ3-PersonalSocial-BLACK"
                label="ASQ3 Personal Social (BLACK)"
                variant="outlined"
                type={"number"}
                InputProps={{
                  inputProps: { min: 0 },
                  startAdornment: (
                    <InputAdornment position="start">{"<="}</InputAdornment>
                  ),
                }}
                value={ASQ3PersonalSocial_CutoffLBValue.toString()}
                onChange={(e) => {
                  if (!!e.target.value) {
                    setASQ3PersonalSocial_CutoffLBValue(
                      parseInt(e.target.value)
                    );
                    setFieldValue(
                      ASQ3PersonalSocial_CutoffLB.name,
                      parseInt(e.target.value)
                    );
                  }
                }}
              ></TextField>
            </Grid>
            <Grid item xs={1} xl={1}></Grid>
            {/* ASQ3PersonalSocial_CutoffUB */}
            <Grid item xs={6} xl={3}>
              <MDTypography variant="body3" fontWeight="bold">
                {ASQ3PersonalSocial_CutoffUB.label}
              </MDTypography>
            </Grid>
            <Grid item xs={5} xl={2}>
              <TextField
                id="ASQ3-PersonalSocial-WHITE"
                label="ASQ3 Personal Social (WHITE)"
                variant="outlined"
                type={"number"}
                InputProps={{
                  inputProps: { min: 0 },
                  startAdornment: (
                    <InputAdornment position="start">{">="}</InputAdornment>
                  ),
                }}
                value={ASQ3PersonalSocial_CutoffUBValue.toString()}
                onChange={(e) => {
                  if (!!e.target.value) {
                    setASQ3PersonalSocial_CutoffUBValue(
                      parseInt(e.target.value)
                    );
                    setFieldValue(
                      ASQ3PersonalSocial_CutoffUB.name,
                      parseInt(e.target.value)
                    );
                  }
                }}
              ></TextField>
            </Grid>
            <Grid item xs={1} xl={1}></Grid>
          </Grid>
        </MDBox>

        <MDBox mb={3} mt={6}>
          <MDTypography variant="h5">(2) Settings for ASQ-SE2</MDTypography>
        </MDBox>

        <MDBox>
          <Grid
            container
            rowSpacing={{ xs: 1, sm: 2 }}
            columnSpacing={{ xs: 1, sm: 3 }}
          >
            {/* ASQ3_SE2_CutoffLB */}
            <Grid item xs={6} xl={3}>
              <MDTypography variant="body3" fontWeight="bold">
                {ASQ3_SE2_CutoffLB.label}
              </MDTypography>
            </Grid>
            <Grid item xs={5} xl={2}>
              <TextField
                id="ASQ3-SE2-WHITE"
                label="ASQ3-SE2 (WHITE)"
                variant="outlined"
                type={"number"}
                InputProps={{
                  inputProps: { min: 0 },
                  startAdornment: (
                    <InputAdornment position="start">{"<="}</InputAdornment>
                  ),
                }}
                value={ASQ3_SE2_CutoffLBValue.toString()}
                onChange={(e) => {
                  if (!!e.target.value) {
                    setASQ3_SE2_CutoffLBValue(parseInt(e.target.value));
                    setFieldValue(
                      ASQ3_SE2_CutoffLB.name,
                      parseInt(e.target.value)
                    );
                  }
                }}
              ></TextField>
            </Grid>
            <Grid item xs={1} xl={1}></Grid>
            {/* ASQ3_SE2_CutoffUB */}
            <Grid item xs={6} xl={3}>
              <MDTypography variant="body3" fontWeight="bold">
                {ASQ3_SE2_CutoffUB.label}
              </MDTypography>
            </Grid>
            <Grid item xs={5} xl={2}>
              <TextField
                id="ASQ3-SE2-BLACK"
                label="ASQ3-SE2 (BLACK)"
                variant="outlined"
                type={"number"}
                InputProps={{
                  inputProps: { min: 0 },
                  startAdornment: (
                    <InputAdornment position="start">{">="}</InputAdornment>
                  ),
                }}
                value={ASQ3_SE2_CutoffUBValue.toString()}
                onChange={(e) => {
                  if (!!e.target.value) {
                    setASQ3_SE2_CutoffUBValue(parseInt(e.target.value));
                    setFieldValue(
                      ASQ3_SE2_CutoffUB.name,
                      parseInt(e.target.value)
                    );
                  }
                }}
              ></TextField>
            </Grid>
            <Grid item xs={1} xl={1}></Grid>
          </Grid>
        </MDBox>

        <MDBox mb={3} mt={6}>
          <MDTypography variant="h5">(3) Settings for SDQ</MDTypography>
        </MDBox>

        <MDBox>
          <Grid
            container
            rowSpacing={{ xs: 1, sm: 2 }}
            columnSpacing={{ xs: 1, sm: 3 }}
          >
            {/* SDQ: Total Difficulties Score */}
            <Grid item xs={6} xl={3}>
              <MDTypography variant="body3" fontWeight="bold">
                Total Difficulties Score
              </MDTypography>
            </Grid>
            <Grid item xs={5} xl={2}>
              <TextField
                id="SDQ-Total-CutoffB1"
                label="VERY HIGH"
                variant="outlined"
                type={"number"}
                InputProps={{
                  inputProps: { min: 0 },
                  startAdornment: (
                    <InputAdornment position="start">{">="}</InputAdornment>
                  ),
                }}
                value={SDQ_Total_CutoffB1Value.toString()}
                onChange={(e) => {
                  if (!!e.target.value) {
                    setSDQ_Total_CutoffB1Value(parseInt(e.target.value));
                    setFieldValue(
                      SDQ_Total_CutoffB1.name,
                      parseInt(e.target.value)
                    );
                  }
                }}
              ></TextField>
            </Grid>
            <Grid item xs={1} xl={1}></Grid>
            <Grid item xs={5} xl={2}>
              <TextField
                id="SDQ-Total-CutoffB2"
                label="HIGH"
                variant="outlined"
                type={"number"}
                InputProps={{
                  inputProps: { min: 0 },
                  startAdornment: (
                    <InputAdornment position="start">{">="}</InputAdornment>
                  ),
                }}
                value={SDQ_Total_CutoffB2Value.toString()}
                onChange={(e) => {
                  if (!!e.target.value) {
                    setSDQ_Total_CutoffB2Value(parseInt(e.target.value));
                    setFieldValue(
                      SDQ_Total_CutoffB2.name,
                      parseInt(e.target.value)
                    );
                  }
                }}
              ></TextField>
            </Grid>
            <Grid item xs={1} xl={1}></Grid>
            <Grid item xs={5} xl={2}>
              <TextField
                id="SDQ-Total-CutoffB3"
                label="SLIGHTLY RAISED"
                variant="outlined"
                type={"number"}
                InputProps={{
                  inputProps: { min: 0 },
                  startAdornment: (
                    <InputAdornment position="start">{">="}</InputAdornment>
                  ),
                }}
                value={SDQ_Total_CutoffB3Value.toString()}
                onChange={(e) => {
                  if (!!e.target.value) {
                    setSDQ_Total_CutoffB3Value(parseInt(e.target.value));
                    setFieldValue(
                      SDQ_Total_CutoffB3.name,
                      parseInt(e.target.value)
                    );
                  }
                }}
              ></TextField>
            </Grid>
            <Grid item xs={1} xl={1}></Grid>

            {/* SDQ: Emotional Problems Score */}
            <Grid item xs={6} xl={3}>
              <MDTypography variant="body3" fontWeight="bold">
                Emotional Problems Score
              </MDTypography>
            </Grid>
            <Grid item xs={5} xl={2}>
              <TextField
                id="SDQ-EmotionalProb-CutoffB1"
                label="VERY HIGH"
                variant="outlined"
                type={"number"}
                InputProps={{
                  inputProps: { min: 0 },
                  startAdornment: (
                    <InputAdornment position="start">{">="}</InputAdornment>
                  ),
                }}
                value={SDQ_EmotionalProb_CutoffB1Value.toString()}
                onChange={(e) => {
                  if (!!e.target.value) {
                    setSDQ_EmotionalProb_CutoffB1Value(
                      parseInt(e.target.value)
                    );
                    setFieldValue(
                      SDQ_EmotionalProb_CutoffB1.name,
                      parseInt(e.target.value)
                    );
                  }
                }}
              ></TextField>
            </Grid>
            <Grid item xs={1} xl={1}></Grid>
            <Grid item xs={5} xl={2}>
              <TextField
                id="SDQ-EmotionalProb-CutoffB2"
                label="HIGH"
                variant="outlined"
                type={"number"}
                InputProps={{
                  inputProps: { min: 0 },
                  startAdornment: (
                    <InputAdornment position="start">{">="}</InputAdornment>
                  ),
                }}
                value={SDQ_EmotionalProb_CutoffB2Value.toString()}
                onChange={(e) => {
                  if (!!e.target.value) {
                    setSDQ_EmotionalProb_CutoffB2Value(
                      parseInt(e.target.value)
                    );
                    setFieldValue(
                      SDQ_EmotionalProb_CutoffB2.name,
                      parseInt(e.target.value)
                    );
                  }
                }}
              ></TextField>
            </Grid>
            <Grid item xs={1} xl={1}></Grid>
            <Grid item xs={5} xl={2}>
              <TextField
                id="SDQ-EmotionalProb-CutoffB3"
                label="SLIGHTLY RAISED"
                variant="outlined"
                type={"number"}
                InputProps={{
                  inputProps: { min: 0 },
                  startAdornment: (
                    <InputAdornment position="start">{">="}</InputAdornment>
                  ),
                }}
                value={SDQ_EmotionalProb_CutoffB3Value.toString()}
                onChange={(e) => {
                  if (!!e.target.value) {
                    setSDQ_EmotionalProb_CutoffB3Value(
                      parseInt(e.target.value)
                    );
                    setFieldValue(
                      SDQ_EmotionalProb_CutoffB3.name,
                      parseInt(e.target.value)
                    );
                  }
                }}
              ></TextField>
            </Grid>
            <Grid item xs={1} xl={1}></Grid>

            {/* SDQ: Conduct Problems Score */}
            <Grid item xs={6} xl={3}>
              <MDTypography variant="body3" fontWeight="bold">
                Conduct Problems Score
              </MDTypography>
            </Grid>
            <Grid item xs={5} xl={2}>
              <TextField
                id="SDQ-ConductProb-CutoffB1"
                label="VERY HIGH"
                variant="outlined"
                type={"number"}
                InputProps={{
                  inputProps: { min: 0 },
                  startAdornment: (
                    <InputAdornment position="start">{">="}</InputAdornment>
                  ),
                }}
                value={SDQ_ConductProb_CutoffB1Value.toString()}
                onChange={(e) => {
                  if (!!e.target.value) {
                    setSDQ_ConductProb_CutoffB1Value(parseInt(e.target.value));
                    setFieldValue(
                      SDQ_ConductProb_CutoffB1.name,
                      parseInt(e.target.value)
                    );
                  }
                }}
              ></TextField>
            </Grid>
            <Grid item xs={1} xl={1}></Grid>
            <Grid item xs={5} xl={2}>
              <TextField
                id="SDQ-ConductProb-CutoffB2"
                label="HIGH"
                variant="outlined"
                type={"number"}
                InputProps={{
                  inputProps: { min: 0 },
                  startAdornment: (
                    <InputAdornment position="start">{">="}</InputAdornment>
                  ),
                }}
                value={SDQ_ConductProb_CutoffB2Value.toString()}
                onChange={(e) => {
                  if (!!e.target.value) {
                    setSDQ_ConductProb_CutoffB2Value(parseInt(e.target.value));
                    setFieldValue(
                      SDQ_ConductProb_CutoffB2.name,
                      parseInt(e.target.value)
                    );
                  }
                }}
              ></TextField>
            </Grid>
            <Grid item xs={1} xl={1}></Grid>
            <Grid item xs={5} xl={2}>
              <TextField
                id="SDQ-ConductProb-CutoffB3"
                label="SLIGHTLY RAISED"
                variant="outlined"
                type={"number"}
                InputProps={{
                  inputProps: { min: 0 },
                  startAdornment: (
                    <InputAdornment position="start">{">="}</InputAdornment>
                  ),
                }}
                value={SDQ_ConductProb_CutoffB3Value.toString()}
                onChange={(e) => {
                  if (!!e.target.value) {
                    setSDQ_ConductProb_CutoffB3Value(parseInt(e.target.value));
                    setFieldValue(
                      SDQ_ConductProb_CutoffB3.name,
                      parseInt(e.target.value)
                    );
                  }
                }}
              ></TextField>
            </Grid>
            <Grid item xs={1} xl={1}></Grid>

            {/* SDQ: Hyperactivity Score */}
            <Grid item xs={6} xl={3}>
              <MDTypography variant="body3" fontWeight="bold">
                Hyperactivity Score
              </MDTypography>
            </Grid>
            <Grid item xs={5} xl={2}>
              <TextField
                id="SDQ-Hyperactivity-CutoffB1"
                label="VERY HIGH"
                variant="outlined"
                type={"number"}
                InputProps={{
                  inputProps: { min: 0 },
                  startAdornment: (
                    <InputAdornment position="start">{">="}</InputAdornment>
                  ),
                }}
                value={SDQ_Hyperactivity_CutoffB1Value.toString()}
                onChange={(e) => {
                  if (!!e.target.value) {
                    setSDQ_Hyperactivity_CutoffB1Value(
                      parseInt(e.target.value)
                    );
                    setFieldValue(
                      SDQ_Hyperactivity_CutoffB1.name,
                      parseInt(e.target.value)
                    );
                  }
                }}
              ></TextField>
            </Grid>
            <Grid item xs={1} xl={1}></Grid>
            <Grid item xs={5} xl={2}>
              <TextField
                id="SDQ-Hyperactivity-CutoffB2"
                label="HIGH"
                variant="outlined"
                type={"number"}
                InputProps={{
                  inputProps: { min: 0 },
                  startAdornment: (
                    <InputAdornment position="start">{">="}</InputAdornment>
                  ),
                }}
                value={SDQ_Hyperactivity_CutoffB2Value.toString()}
                onChange={(e) => {
                  if (!!e.target.value) {
                    setSDQ_Hyperactivity_CutoffB2Value(
                      parseInt(e.target.value)
                    );
                    setFieldValue(
                      SDQ_Hyperactivity_CutoffB2.name,
                      parseInt(e.target.value)
                    );
                  }
                }}
              ></TextField>
            </Grid>
            <Grid item xs={1} xl={1}></Grid>
            <Grid item xs={5} xl={2}>
              <TextField
                id="SDQ-Hyperactivity-CutoffB3"
                label="SLIGHTLY RAISED"
                variant="outlined"
                type={"number"}
                InputProps={{
                  inputProps: { min: 0 },
                  startAdornment: (
                    <InputAdornment position="start">{">="}</InputAdornment>
                  ),
                }}
                value={SDQ_Hyperactivity_CutoffB3Value.toString()}
                onChange={(e) => {
                  if (!!e.target.value) {
                    setSDQ_Hyperactivity_CutoffB3Value(
                      parseInt(e.target.value)
                    );
                    setFieldValue(
                      SDQ_Hyperactivity_CutoffB3.name,
                      parseInt(e.target.value)
                    );
                  }
                }}
              ></TextField>
            </Grid>
            <Grid item xs={1} xl={1}></Grid>

            {/* SDQ: Peer Problems Score */}
            <Grid item xs={6} xl={3}>
              <MDTypography variant="body3" fontWeight="bold">
                Peer Problems Score
              </MDTypography>
            </Grid>
            <Grid item xs={5} xl={2}>
              <TextField
                id="SDQ-PeerProb-CutoffB1"
                label="VERY HIGH"
                variant="outlined"
                type={"number"}
                InputProps={{
                  inputProps: { min: 0 },
                  startAdornment: (
                    <InputAdornment position="start">{">="}</InputAdornment>
                  ),
                }}
                value={SDQ_PeerProb_CutoffB1Value.toString()}
                onChange={(e) => {
                  if (!!e.target.value) {
                    setSDQ_PeerProb_CutoffB1Value(parseInt(e.target.value));
                    setFieldValue(
                      SDQ_PeerProb_CutoffB1.name,
                      parseInt(e.target.value)
                    );
                  }
                }}
              ></TextField>
            </Grid>
            <Grid item xs={1} xl={1}></Grid>
            <Grid item xs={5} xl={2}>
              <TextField
                id="SDQ-PeerProb-CutoffB2"
                label="HIGH"
                variant="outlined"
                type={"number"}
                InputProps={{
                  inputProps: { min: 0 },
                  startAdornment: (
                    <InputAdornment position="start">{">="}</InputAdornment>
                  ),
                }}
                value={SDQ_PeerProb_CutoffB2Value.toString()}
                onChange={(e) => {
                  if (!!e.target.value) {
                    setSDQ_PeerProb_CutoffB2Value(parseInt(e.target.value));
                    setFieldValue(
                      SDQ_PeerProb_CutoffB2.name,
                      parseInt(e.target.value)
                    );
                  }
                }}
              ></TextField>
            </Grid>
            <Grid item xs={1} xl={1}></Grid>
            <Grid item xs={5} xl={2}>
              <TextField
                id="SDQ-PeerProb-CutoffB3"
                label="SLIGHTLY RAISED"
                variant="outlined"
                type={"number"}
                InputProps={{
                  inputProps: { min: 0 },
                  startAdornment: (
                    <InputAdornment position="start">{">="}</InputAdornment>
                  ),
                }}
                value={SDQ_PeerProb_CutoffB3Value.toString()}
                onChange={(e) => {
                  if (!!e.target.value) {
                    setSDQ_PeerProb_CutoffB3Value(parseInt(e.target.value));
                    setFieldValue(
                      SDQ_PeerProb_CutoffB3.name,
                      parseInt(e.target.value)
                    );
                  }
                }}
              ></TextField>
            </Grid>
            <Grid item xs={1} xl={1}></Grid>

            {/* SDQ: Prosocial Score */}
            <Grid item xs={6} xl={3}>
              <MDTypography variant="body3" fontWeight="bold">
                Prosocial Score
              </MDTypography>
            </Grid>
            <Grid item xs={5} xl={2}>
              <TextField
                id="SDQ-Prosocial-CutoffB1"
                label="VERY LOW"
                variant="outlined"
                type={"number"}
                InputProps={{
                  inputProps: { min: 0 },
                  startAdornment: (
                    <InputAdornment position="start">{"<="}</InputAdornment>
                  ),
                }}
                value={SDQ_Prosocial_CutoffB1Value.toString()}
                onChange={(e) => {
                  if (!!e.target.value) {
                    setSDQ_Prosocial_CutoffB1Value(parseInt(e.target.value));
                    setFieldValue(
                      SDQ_Prosocial_CutoffB1.name,
                      parseInt(e.target.value)
                    );
                  }
                }}
              ></TextField>
            </Grid>
            <Grid item xs={1} xl={1}></Grid>
            <Grid item xs={5} xl={2}>
              <TextField
                id="SDQ-Prosocial-CutoffB2"
                label="LOW"
                variant="outlined"
                type={"number"}
                InputProps={{
                  inputProps: { min: 0 },
                  startAdornment: (
                    <InputAdornment position="start">{"<="}</InputAdornment>
                  ),
                }}
                value={SDQ_Prosocial_CutoffB2Value.toString()}
                onChange={(e) => {
                  if (!!e.target.value) {
                    setSDQ_Prosocial_CutoffB2Value(parseInt(e.target.value));
                    setFieldValue(
                      SDQ_Prosocial_CutoffB2.name,
                      parseInt(e.target.value)
                    );
                  }
                }}
              ></TextField>
            </Grid>
            <Grid item xs={1} xl={1}></Grid>
            <Grid item xs={5} xl={2}>
              <TextField
                id="SDQ-Prosocial-CutoffB3"
                label="SLIGHTLY LOWERED"
                variant="outlined"
                type={"number"}
                InputProps={{
                  inputProps: { min: 0 },
                  startAdornment: (
                    <InputAdornment position="start">{"<="}</InputAdornment>
                  ),
                }}
                value={SDQ_Prosocial_CutoffB3Value.toString()}
                onChange={(e) => {
                  if (!!e.target.value) {
                    setSDQ_Prosocial_CutoffB3Value(parseInt(e.target.value));
                    setFieldValue(
                      SDQ_Prosocial_CutoffB3.name,
                      parseInt(e.target.value)
                    );
                  }
                }}
              ></TextField>
            </Grid>
            <Grid item xs={1} xl={1}></Grid>
          </Grid>
        </MDBox>
      </MDBox>
    </Card>
  );
}

export default ParamSettings;
